import React from 'react';

const Lamp = () => (
  <path d="M20 15h2l.0001 2h-2L20 15zm-3 7.083c2.8377.476 5 2.944 5 5.917v1H10v-1c0-2.973 2.1623-5.441 5-5.917L15.0001 15h2L17 22.083zm4-.583c-1.3807 0-2.5-1.1193-2.5-2.5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5-1.1193 2.5-2.5 2.5zm0-2a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM11.6667 3h8.6666a1 1 0 0 1 .9231.6154l4.1667 10c.2124.5098-.0287 1.0953-.5385 1.3077A1 1 0 0 1 24.5 15h-17c-.5523 0-1-.4477-1-1a1 1 0 0 1 .077-.3846l4.1666-10A1 1 0 0 1 11.6666 3zm.6666 2L9 13h14l-3.3333-8h-7.3334zM16 24c-1.8638 0-3.43 1.2748-3.874 3h7.748c-.444-1.7252-2.0102-3-3.874-3z" />
);

export default Lamp;
